module.exports = __webpack_public_path__ + "img/pc_leaf_L.e8c87a5.webp";